import React from "react";
import ReactModal from "react-modal";
import "../modal.css"; // Optional: Add custom styles for the modal

const Modal = ({ isOpen, onRequestClose, children }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Modal"
      className="modal-content" // Custom class for the modal content
      overlayClassName="modal-overlay" // Custom class for the overlay
      closeTimeoutMS={300}
    >
      {children}
    </ReactModal>
  );
};

export default Modal;
